import React from "react";
import { Clock } from "lucide-react";

const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
const MINUTES = ["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"];

// Hour/minute dropdowns instead of <input type="time">, which is unreliable on
// Android browsers (the native spinner often won't commit a value).
export default function TimeField({ value = "08:00", onChange, testid = "time-field" }) {
  const [h = "08", m = "00"] = String(value || "08:00").split(":");
  const minute = MINUTES.includes(m) ? m : "00";
  const sel = "h-11 bg-black/50 border border-white/15 px-2 text-sm text-white outline-none focus:border-[#E2E30A]";

  return (
    <div className="flex items-center gap-2" data-testid={testid}>
      <Clock className="h-4 w-4 text-[#E2E30A] shrink-0" />
      <select data-testid={`${testid}-hour`} className={sel} value={HOURS.includes(h) ? h : "08"}
        onChange={(e) => onChange(`${e.target.value}:${minute}`)}>
        {HOURS.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
      <span className="text-zinc-400 font-mono">:</span>
      <select data-testid={`${testid}-minute`} className={sel} value={minute}
        onChange={(e) => onChange(`${HOURS.includes(h) ? h : "08"}:${e.target.value}`)}>
        {MINUTES.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
    </div>
  );
}
